import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useLocalizedFormattedText from '@frolight/hooks/useLocalizedFormattedText';

const GatewayListItem = ({ gateway }) => {
  const { lftext } = useLocalizedFormattedText();

  return (
    <li className="list__item" key={ `gateway-${gateway.id}` }>
      <div className="list_item">
        <div className="list_item__content">
          <h3 className="list_item__title">
            <Link className="list_item__link" to={ `/gateways/${gateway.id}` }>{ gateway.name }</Link>
          </h3>
          <span className="list_item__icon">
            {
              gateway.connected ? (
                <i className="icon  icon--success">cloud</i>
              ) : (
                <i className="icon  icon--error">cloud_off</i>
              )
            }
          </span>
          <span className="list_item__meta">
            {lftext('common.last_message')} {
              gateway.lastMessageTimestamp ? (
                new Date(gateway.lastMessageTimestamp * 1000).toLocaleString()
              ) : (
                <>
                  {lftext('common.not_available')}
                </>
              )
            }
          </span>
        </div>
      </div>
    </li>
  );
}

GatewayListItem.propTypes = {
  gateway: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    lastMessageTimestamp: PropTypes.number
  }).isRequired
};

export default GatewayListItem;
